var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.alert)?_c('v-alert',{class:_vm.alert.class,attrs:{"type":_vm.alert.type,"value":true,"icon":_vm.icon}},[_vm._v(" "+_vm._s(_vm.$$t(_vm.alert.text))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }